import React from 'react';
import './Counter.css';

import { counter } from '../../../constants';

import CountUp from 'react-countup';



const Counter = () => {

  return (

    <div className='counting'>

      {/* Render each counter */}
      {counter.map((count) => {
        return (
          <div className='box' key={count.id}>
            <div className='info'>
              <div className='icon'>{count.icon}</div> {/* Counter icon */}
              <div className='content'>
                <CountUp className='count' end={count.count} duration={3} suffix={'+'} /> {/* Animate the count */}
                <div className='line'></div> {/* Decorative Line */}
                <h3>{count.title}</h3> {/* Counter title */}
              </div>
            </div>
          </div>
        );
      })}
      </div>

  );
}

export default Counter;